/** 수식·이미지 하나로만 이뤄진 문항은 텍스트가 없어도 내용이 있다. */
const CONTENT_BEARING_MARKUP = /<(img|math-inline)[\s/>]|data-latex=/i;

/**
 * 태그를 걷어낸 실제 내용이 있는지. 에디터가 빈 문단을 `<p></p>`·`&nbsp;` 로
 * 남기므로 truthy 검사만으로는 빈 리치 텍스트를 잡지 못한다.
 */
export const hasContent = (html: string | null | undefined): boolean => {
  if (!html) return false;
  if (CONTENT_BEARING_MARKUP.test(html)) return true;
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
      .trim().length > 0
  );
};

/**
 * 문제 본문. 리치 텍스트가 우선이되 비어 있으면 평문으로 내려가고, 둘 다 비면
 * 빈 문자열 — 호출부가 그 문항을 뺀다(`QuizBaseSchema` 의 `min(1)` 에 걸린다).
 */
export const toStem = (data: {
  question?: string | null;
  questionRichText?: string | null;
}): string => {
  const { question, questionRichText } = data;
  if (hasContent(questionRichText)) return questionRichText ?? '';
  return question?.trim() ? question : '';
};
